export default __webpack_public_path__ + "static/media/button-mini-alter.5d8e5fad.svg";